import styled from 'styled-components';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const CheckboxArea = styled.div`
  align-items: flex-start;
  background: var(--color-bg-body, #fff);
  border: 1px solid var(--color-border-default, #e5e8ef);
  border-radius: var(--size-border-radius-md, 4px);
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-8);
  padding: var(--size-padding-12);
`;

const CheckboxGroup = styled.div``;

const CopyTextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-4);
`;

export { CheckboxArea, CheckboxGroup, Content, CopyTextArea };
